import React from 'react';
import {Button, Row} from 'reactstrap';
import {Panel} from "primereact/panel";
import DataTable from "../../../shared/component/dataTable/DataTable";
import ExternalResolutionMapColumn from "../../../shared/component/dataTable/columns/ExternalResolutionMapColumn.json";
import Toolbar from "../../../shared/component/toolbar/Toolbar";
import GeneralUtils from "../../../shared/utils/GeneralUtils";
import Translate from "../../../shared/language/Translate";
import Dialog from "../../../shared/component/dialog/Dialog";
import {PAGE_MODE} from "../../../shared/utils/Constants";
import {AvForm} from "availity-reactstrap-validation";
import ExternalResolutionMapSave from "./ExternalResolutionMapSave";
import ExternalResolutionMapService from "../../../shared/service/ExternalResolutionMapService";


class ExternalResolutionMap extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            pageMode: null
        };
        this.service = new ExternalResolutionMapService();
    }

    render() {
        return (
            <Row className="justify-content-center">
                <Panel header="Dış Sistem Çözüm Kodu Eşleştirmeleri" style={{width: '75%'}}>
                    <Toolbar display={true}>
                        <div className="p-toolbar-group-right">
                            <Button color="primary" onClick={this.addNew}>
                                <Translate contentKey="entity.action.add">Yeni Kayıt</Translate>
                            </Button>
                        </div>
                    </Toolbar>

                    <DataTable ref={(elem) => this.refDataTable = elem} fields={ExternalResolutionMapColumn.fields} dataURL="externalResolutionMap/findAll"
                               privilege="allow"
                               selectionMode="single" onDataSelect={this.onDataSelect} export={true}/>

                    <Dialog visible={this.state.displayDialog}
                            header={GeneralUtils.getDialogHeader('Çözüm Kodu Eşleştirme', this.state.pageMode)}
                            onHide={() => this.setState({displayDialog: false})} style={{width: '50%'}}>
                        <AvForm onValidSubmit={this.save}>
                            <Toolbar
                                display={true}>
                                <div className="p-toolbar-group-right">
                                    <Button color="primary" type="submit" className="float-right">
                                        <Translate contentKey="entity.action.save">Kaydet</Translate>
                                    </Button>
                                    <Button color="primary" className="float-right"
                                            onClick={() => this.setState({displayDialog: false})}>
                                        <Translate contentKey="entity.action.save">Vazgeç</Translate>
                                    </Button></div>

                            </Toolbar>
                            <ExternalResolutionMapSave ref={elem => this.refExternalResolutionMapSave = elem}/>
                        </AvForm>
                    </Dialog>
                </Panel>
            </Row>
        );
    }

    refresh = () => {
        this.refDataTable.refresh();
    }

    addNew = () => {
        this.setState({displayDialog: true, pageMode: PAGE_MODE.CREATE});
        this.refExternalResolutionMapSave.clearData();
    }

    onDataSelect = (data) => {
        let pageMode = GeneralUtils.getPageModeFromPrivilege(ExternalResolutionMapColumn.name);
        this.setState({displayDialog: true, pageMode: pageMode});
        this.refExternalResolutionMapSave.clearData();
        this.refExternalResolutionMapSave.setData(Object.assign({}, data), pageMode);
    }

    save = () => {
        let externalResolutionMap = this.refExternalResolutionMapSave.getData();
        if (!GeneralUtils.isNullOrEmpty(externalResolutionMap.id)) {
            this.service.update(externalResolutionMap).then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({displayDialog: false});
                    this.refresh();
                }
            });
        } else {
            this.service.create(externalResolutionMap).then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({displayDialog: false});
                    this.refresh();
                }
            });
        }
    }
}


export default ExternalResolutionMap;
